import { ReactNode, cloneElement, forwardRef } from 'react';

import { TPermissions, TUserRoles } from '@cloud-wave/neon-common-lib';

import { OneOrMany } from 'lib/core/types';

import { usePermissionsContext } from 'lib/common/contexts/PermissionsContext';

import { TConnectPermissions, TPermissionTypes } from 'lib/common/types/Permissions';

import { anyValidUser } from '../../../routes/userRoleCombinations';

type AuthorisedRouteProps = {
  permission?: OneOrMany<TPermissions | TConnectPermissions>;
  permissionType?: TPermissionTypes;
  fallback?: ReactNode;
  children?: ReactNode;
  allowedRoles?: TUserRoles[];
};

function getChild(children, ref) {
  if (!ref) {
    return children;
  }

  return cloneElement(children, { ref });
}

function RequiresPermission(
  { permission, permissionType, allowedRoles = anyValidUser, children = null, fallback = null }: AuthorisedRouteProps,
  ref
) {
  const { hasPermission, role } = usePermissionsContext();
  const hasCorrectRole = allowedRoles.length ? allowedRoles.includes(role) : true;

  const hasCorrectPermissions = Array.isArray(permission)
    ? permission.every((permission) => hasPermission({ type: permissionType, permission }))
    : hasPermission({ type: permissionType, permission });

  if (!hasCorrectPermissions || !hasCorrectRole) {
    return fallback;
  }

  return getChild(children, ref);
}

export default forwardRef(RequiresPermission);
